import * as React from 'react';
import type { SVGProps } from 'react';

export const SvgDragIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      color: 'inherit',
      ...props.style,
    }}
  >
    <circle cx="9.5" cy="6" r="0.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="9.5" cy="10" r="0.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="9.5" cy="14" r="0.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="9.5" cy="18" r="0.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="14.5" cy="6" r="0.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="14.5" cy="10" r="0.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="14.5" cy="14" r="0.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="14.5" cy="18" r="0.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
